import { render, staticRenderFns } from "./StatEntrances.vue?vue&type=template&id=706a6e32&scoped=true&"
import script from "./StatEntrances.vue?vue&type=script&lang=ts&"
export * from "./StatEntrances.vue?vue&type=script&lang=ts&"
import style0 from "./StatEntrances.vue?vue&type=style&index=0&id=706a6e32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706a6e32",
  null
  
)

component.options.__file = "StatEntrances.vue"
export default component.exports